import React, { ReactElement } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import FlexContainer from '../flex-container/flex-container.component';
import { ACCENT_COLORS_SHORT, COLORS } from '../../constants/system/colors';

const ChartBar: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const CHART_BAR_BORDER_WIDTH: number = 1;
  const CHART_BAR_BAR_MAX_WIDTH: number = 50;
  const CHART_BAR_PADDING: number = 25;
  const CHART_BAR_HEIGHT: number = 300;
  const CHART_BAR_WIDTH: number = 640;
  const CHART_BAR_PADDING_TOP: number = 10;
  const CHART_BAR_DATA_LABEL_ALIGN_END: ChartLabelAlignment = 'end';
  const CHART_BAR_DATA_LABEL_ANCHOR_START: ChartLabelAnchor = 'start';

  const {
    containerId,
    chartItemList,
    chartItemsLimit,
  } = props;

  const chartBarLabelList: string[] = (chartItemsLimit ? chartItemList.slice(0, chartItemsLimit) : chartItemList)
    .map((chartItem: ChartBarItem): string => chartItem.name);
  const chartBarValueList: number[] = (chartItemsLimit ? chartItemList.slice(0, chartItemsLimit) : chartItemList)
    .map((chartItem: ChartBarItem): number => chartItem.value);

  Chart.register(...registerables);

  return (
    <FlexContainer
      isCentered
      style={{
        paddingTop: CHART_BAR_PADDING_TOP,
      }}
    >
      {
        chartItemList && !!chartItemList.length && (
          <Bar
            id={containerId}
            height={CHART_BAR_HEIGHT}
            width={CHART_BAR_WIDTH}
            data={{
              labels: chartBarLabelList,
              datasets: [
                {
                  label: '',
                  data: chartBarValueList,
                  backgroundColor: ACCENT_COLORS_SHORT,
                  borderWidth: CHART_BAR_BORDER_WIDTH,
                  maxBarThickness: CHART_BAR_BAR_MAX_WIDTH,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: {
                  grid: {
                    display: false,
                  },
                },
                y: {
                  grid: {
                    display: false,
                  },
                },
              },
              layout: {
                padding: CHART_BAR_PADDING,
              },
              plugins: {
                legend: {
                  display: false,
                },
                tooltip: {
                  enabled: false,
                },
                datalabels: {
                  color: COLORS.black,
                  align: CHART_BAR_DATA_LABEL_ALIGN_END,
                  anchor: CHART_BAR_DATA_LABEL_ANCHOR_START,
                },
              },
            }}
            plugins={[ChartDataLabels]}
          />
        )
      }
    </FlexContainer>
  );
});

export default ChartBar;
